import { render, staticRenderFns } from "./detailTables.vue?vue&type=template&id=505df212&scoped=true"
import script from "./detailTables.vue?vue&type=script&lang=js"
export * from "./detailTables.vue?vue&type=script&lang=js"
import style0 from "./detailTables.vue?vue&type=style&index=0&id=505df212&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505df212",
  null
  
)

export default component.exports